import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextfieldComponent } from './textfield/textfield.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormRowComponent } from './form-row/form-row.component';
import { DatefieldComponent } from './datefield/datefield.component';
import { FilefieldComponent } from './filefield/filefield.component';
import { RadiofieldsComponent } from './radiofields/radiofields.component';
import { CheckboxfieldComponent } from './checkboxfield/checkboxfield.component';
import { SelectfieldComponent } from './selectfield/selectfield.component';
import { TextareafieldComponent } from './textareafield/textareafield.component';
import { TablefieldComponent } from './tablefield/tablefield.component';
import { FieldErrorsComponent } from './field-errors/field-errors.component';
import { FieldWarningsComponent } from './field-warnings/field-warnings.component';
import { NumberfieldComponent } from './numberfield/numberfield.component';
import { HiddenfieldComponent } from './hiddenfield/hiddenfield.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomNumberInputComponent } from './custom-number-input/custom-number-input.component';
import { ToFormControlPipe } from '@shared/components/form/pipes/to-form-control.pipe';
import {
    CustomNumericStringInputComponent
} from '@shared/components/form/custom-numeric-string-input/custom-numeric-string-input.component';
import {
    BooleanCheckboxInputComponent
} from '@shared/components/form/boolean-checkbox-input/boolean-checkbox-input.component';
import { RevertOnInvalidDirective } from '@shared/components/form/directives/revert-on-invalid.directive';
import { FieldBlurDirective } from '@shared/components/form/directives/field-blur.directive';

@NgModule({
    declarations: [
        TextfieldComponent,
        FormRowComponent,
        DatefieldComponent,
        FilefieldComponent,
        RadiofieldsComponent,
        CheckboxfieldComponent,
        SelectfieldComponent,
        TextareafieldComponent,
        TablefieldComponent,
        FieldErrorsComponent,
        FieldWarningsComponent,
        NumberfieldComponent,
        HiddenfieldComponent,
        CustomNumberInputComponent,
        ToFormControlPipe,
        CustomNumericStringInputComponent,
        BooleanCheckboxInputComponent,
        RevertOnInvalidDirective,
        FieldBlurDirective,
    ],
    exports: [
        TextfieldComponent,
        FormRowComponent,
        DatefieldComponent,
        FilefieldComponent,
        RadiofieldsComponent,
        CheckboxfieldComponent,
        SelectfieldComponent,
        TextareafieldComponent,
        TablefieldComponent,
        NumberfieldComponent,
        HiddenfieldComponent,
        CustomNumberInputComponent,
        FieldErrorsComponent,
        ToFormControlPipe,
        CustomNumericStringInputComponent,
        FieldWarningsComponent,
        BooleanCheckboxInputComponent,
        RevertOnInvalidDirective,
        FieldBlurDirective,
    ],
    imports: [CommonModule, NgbTooltipModule, ReactiveFormsModule],
})
export class FormComponentsModule {
    public constructor() {}
}
